import { useEffect, useState } from "react";
import CloseIcon from "../../assets/icons/close.svg";

import "../../utils/styles/modal.css";
import "./ModalEditCategory.css";
import { categoryService } from "../../services/category.service";
import { closeModal, showModal } from "../../utils/functions/modal";

const ModalEditCategory = ({ setMessage, category, onSuccess }) => {
  const [nameCategory, setNameCategory] = useState("");

  useEffect(() => {
    setNameCategory(category?.nombre || "");
  }, [category]);

  const handleSubmitCategory = async (e) => {
    e.preventDefault();
    if (!category?.id) return;

    closeModal(".container-modal-edit-category");
    showModal(".container-modal-confirm");
    setMessage({
      description: "Editando categoría...",
      status: 1000,
    });

    const response = await categoryService.editCategory(
      category.id,
      nameCategory.trim()
    );

    setTimeout(() => {
      if (response.data.status === 200) {
        onSuccess?.();
      }
      setMessage({
        description: response.data.message,
        status: response.data.status,
      });
    }, 1500);
  };

  return (
    <>
      <div className="container-modal container-modal-edit-category">
        <div className="modal modal-edit-category">
          <div className="header-modal">
            <h3>Editar Categoría</h3>
            <button
              onClick={() => closeModal(".container-modal-edit-category")}
            >
              <img src={CloseIcon} alt="" />
            </button>
          </div>
          <form onSubmit={handleSubmitCategory} className="body-modal">
            <div className="input">
              <label htmlFor="nameEditCategory">Nombre</label>
              <input
                type="text"
                id="nameEditCategory"
                name="nameEditCategory"
                required
                onChange={(e) => setNameCategory(e.target.value)}
                value={nameCategory}
                placeholder="Accesorios"
              />
            </div>

            <button className="btn-add-product">EDITAR CATEGORÍA</button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ModalEditCategory;
